import { Route, Redirect } from "react-router-dom";
import {isAuthenticated} from '../../api'

const SellerRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() && isAuthenticated().user.role === "seller" ? (
        <Component {...props} />
      ) : (
        <Redirect to="/error/403" />
      )
    }
  />
);

export default SellerRoute;
